// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609071108/js/" + chunkId + "." + {"44":"637ecbda","225":"e9e0671a","481":"32329b22","486":"92daf86e","770":"37fefd50"}[chunkId] + ".0.6687350435340699.chunk.js";
};